import ActionResult from 'app/src/engine/action-results/ActionResult';
import GameStateStore from 'app/src/game/GameStateStore';

export default class TileInteraction {
	// Subclasses should override priority. When executing tile interactions,
	// they will be executed in priority order.
	get priority(): number {
		return 0;
	}

	// Interactions can span multiple segments. Is this interaction
	// finished executing all segments this turn?
	//
	// Subclasses must override.
	get finishedExecuting(): boolean {
		throw new Error('Subclasses must override.');
	}

	// Interactions need to be reset after being used.
	//
	// Subclasses should override.
	public reset(): void {
		// Virtual.
	}

	// For a certain type of tile, perform all movements and other
	// interaction on the elements of the game and return the results
	// that caused these movements.
	public executeSegment(gameStateStore: GameStateStore): ActionResult[] {
		if (this.finishedExecuting) {
			throw new Error('TileInteraction needs resetting before it can be used.');
		}

		return this._executeSegment(gameStateStore);
	}

	// Protected method for executing segments. No outsiders should call
	// this method.
	//
	// Subclasses must override.
	public _executeSegment(_gameStateStore: GameStateStore): ActionResult[] {
		throw new Error('Subclasses must override.');
	}
}
